'use client';
import { DialogStyled } from './dialog.styles';

const Dialog = DialogStyled;

export default Dialog;
